import React from 'react';
import { Helmet } from 'react-helmet-async';
import {
  absoluteUrl,
  DEFAULT_DESCRIPTION,
  DEFAULT_IMAGE,
  DEFAULT_TITLE,
  SEO_KEYWORDS,
  SITE_LOCALE,
  SITE_NAME,
} from '../constants/seo';

/**
 * Per-page SEO head tags for public routes.
 * `jsonLd` accepts one schema.org object or an array of them.
 */
export default function SeoHead({
  title,
  description,
  path = '/',
  keywords = SEO_KEYWORDS,
  image,
  type = 'website',
  noindex = false,
  jsonLd,
}) {
  const pageTitle = title || DEFAULT_TITLE;
  const pageDescription = description || DEFAULT_DESCRIPTION;
  const canonical = absoluteUrl(path);
  const imageUrl = image ? absoluteUrl(image) : DEFAULT_IMAGE;
  const schemas = (Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : []).filter(Boolean);

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      {noindex ? <meta name="robots" content="noindex, follow" /> : null}
      {noindex ? null : <link rel="canonical" href={canonical} />}
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content={SITE_LOCALE} />
      <meta property="og:image" content={imageUrl} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={imageUrl} />
      {schemas.map((schema, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}
